import React, { useState, useEffect } from "react";
import { GraduationCap, ArrowRight, X } from "lucide-react";

const STORAGE_KEY = "finx_announcement_dismissed";

const AnnouncementBar = ({ onApplyClick }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY) === "1") setVisible(false);
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="announcement-bar"
      className="relative z-40 brand-gradient text-white text-sm font-semibold"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-2.5 flex items-center justify-center gap-3 flex-wrap">
        <span className="inline-flex items-center gap-2">
          <GraduationCap size={16} className="shrink-0" />
          <span className="font-bold">FinX Campus Ambassadors are open — apply now to earn XP, Fifi merch & payouts.</span>
        </span>
        <button
          onClick={onApplyClick}
          data-testid="announcement-apply-btn"
          className="inline-flex items-center gap-1 bg-white/20 hover:bg-white/30 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide transition-colors"
        >
          Apply <ArrowRight size={12} />
        </button>
        <button
          onClick={dismiss}
          aria-label="Dismiss"
          data-testid="announcement-dismiss"
          className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
